<template>
  <Adsense
    :data-ad-slot="dataAdSlot"
    :width="320"
    :height="50"
    style="display:inline-block;width:320px;height:50px"
    data-ad-format="horizontal"
  ></Adsense>
</template>

<script>
import Adsense from './Adsense'

export default {
  components: {
    Adsense
  },

  props: {
    dataAdSlot: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdsenseSp.vue